import {Types} from "@Common/types";

import {chain}              from "../../utils/fs";
import {filterKeys, values} from "../../utils/objects";

export const OPTION_SIZE = "Size";

export const getPickPack = (templateOptions) => chain(
    templateOptions.options.filter((o) => o.devKey === "pick_pack_options")[0]?.value,
    (value) => value && JSON.parse(value)
);
export const getPickPackOptions1 = (pickPack:Types.Common.Logic.TemplateOptions.PickPack.PickPack) => pickPack && pickPack.options && (
    filterKeys(pickPack.options, (option) => pickPack.client_facing[option] === 1)
);
export const getPickPackOptions = (templateOptions) => chain(
    getPickPack(templateOptions),
    getPickPackOptions1,
);

export const getPickPackSizeOptions = (pickPack:Types.Common.Logic.TemplateOptions.PickPack.PickPack) => pickPack?.options?.[OPTION_SIZE];

export const getPickPackOutOfStock = (pickPack:Types.Common.Logic.TemplateOptions.PickPack.PickPack) => (
    !pickPack?.out_of_stock || pickPack?.out_of_stock === "[]" ? [] : values(pickPack.out_of_stock)
);

export const isPickPack = (templateOptions) => templateOptions?.product?.idProductType === 6;

export const is3rdPartyWorkflow = (templateOptions) => {
    const workflow = templateOptions?.options?.find((o) => o?.devKey === "workflow")?.value
    return workflow === "3rd_party"
}

export const isKit = (templateOptions) => ( templateOptions?.options?.find(v => v.devKey === "kit_type")?.value == 'kit' || templateOptions?.options?.find(v => v.devKey === "kit_type")?.value == 'kit_only' );

export const isUyoMPB = (templateOptions) => ( !!templateOptions?.options?.find(v => v.devKey === "is_uyo")?.value && templateOptions?.enableMultipageValidation);

/**
 * Create a cal with single-value options preselected
 */
export const makeBaseCal = (pickPack:Types.Common.Logic.TemplateOptions.PickPack.PickPack):Types.Common.Logic.TemplateOptions.PickPack.PickPackCal => (
    Object.keys({...getPickPackOptions1(pickPack), [OPTION_SIZE]: getPickPackSizeOptions(pickPack)}).reduce((cal, option) => {
        const optionValues = values(pickPack?.options?.[option] ?? {});
        return {
            ...cal,
            ...(optionValues.length === 1 && {[option]: optionValues[0]})
        };
    }, {})
);

/**
 * Creates a function that can test if a "cal" combination is eligible
 */
export const makeCalOutOfStockTest = (pickPack:Types.Common.Logic.TemplateOptions.PickPack.PickPack) => (
    (cal:Types.Common.Logic.TemplateOptions.PickPack.PickPackCal):boolean => (
        getPickPackOutOfStock(pickPack).some(outOfStockCal => Object.keys(pickPack?.options ?? {}).every(
            (option) => !outOfStockCal[option] || outOfStockCal[option] === cal[option]
        ))
    )
);

/**
 * Creates a function that removes out of stock values from a cal, based on an option to pivot around
 *
 * NOTE: The result may have fewer options than could possibly be selected around the pivot
 */
export const makeCalOutOfStockTrim = (outOfStockTest:ReturnType<typeof makeCalOutOfStockTest>) => (
    (cal:Types.Common.Logic.TemplateOptions.PickPack.PickPackCal, pivotOption:string):Types.Common.Logic.TemplateOptions.PickPack.PickPackCal => (
        Object.keys(cal).reduce((resultCal, option) => ({
            ...resultCal,
            ...(!outOfStockTest({...resultCal, [option]: cal[option]}) && {[option]: cal[option]})
        }), {[pivotOption]: cal[pivotOption]})
    )
);

